<template>
	<div ref="Policy-main" :class="{ 'Policy-main-mobile': isMobile }" class="Policy-main">
		<Base-title :title="title"></Base-title>
		<div v-if="!isMobile" class="Policy-content">
			<div v-if="fixed" class="Policy-content-left"></div>
			<div :class="{ 'content-fixed': fixed }" class="Policy-content-left">
				<div class="Policy-guide-text">本声明主要向您说明：</div>
				<div class="Policy-content-tree">
					<el-tree
							ref="tree"
							:data="data"
							:default-expanded-keys="[1]"
							:props="defaultProps"
							current-node-key="二级 1-1"
							node-key="id"
							@node-click="handleNodeClick"
					></el-tree>
				</div>
			</div>
			<div class="Policy-content-right" @click="htmlScroll" v-html="content"></div>
		</div>
		<div v-else class="Policy-content" @click="htmlScroll" v-html="content"></div>
	</div>
</template>
<script>
import {documentObj} from './content.js';
// import variable from '@/assets/scss/global.variable.module.scss';

export default {
    // 贝壳隐私政策
    name: 'Policy',
    data() {
        return {
            fixed: false,
            content: documentObj[this.$route.name]?.html,
            data: documentObj[this.$route.name]?.list,
            title: documentObj[this.$route.name]?.title,
					images: {head: require('@/assets/images/privacyPolicy/head.png'),},
            defaultProps: {
                children: 'children',
                label: 'label'
            }
        };
    },
    computed: {
        htmlSize() {
            return (
                this.$store.state.mobile.htmlSize ||
                parseFloat(document.getElementsByTagName('html')[0].style.fontSize)
            );
        }
    },
    created() {
        window.addEventListener('scroll', this.handleScroll, true);
    },
    mounted() {
        let content = this.$route.query?.content;
        if (content) {
            const isMobile = window?.isMobile;
            let elementArr =
                document.querySelector(isMobile ? '.Policy-content' : '.Policy-content-right')
                    ?.childNodes || [];
            let element = Array.from(elementArr).find((v) => {
                return v?.innerText && v?.innerText?.indexOf(content) !== -1;
            });
            console.log(element, 11);
            if (element) {
                element?.scrollIntoView({
                    block: isMobile ? 'center' : 'start',
                    inline: 'nearest'
                });
                element.style.background = 'rgba(0,114,245,.3)';
                setTimeout(() => {
                    element.style.background = '';
                }, 1000);
            }
        }
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll, true);
    },
    methods: {
        // 滚动时控制左侧导航栏的位置
        handleScroll() {
            let root = document.querySelector(':root');
            let multiple = +getComputedStyle(root).getPropertyValue('--size');
            if (!multiple) multiple = document.documentElement.clientWidth >= 1920 ? 1 : 1;
            //当元素距离顶部小于50px（header高度）+ padding-top时，使用固定定位
            let scrollTop = this.$refs['Policy-main']?.getBoundingClientRect().top;
            this.fixed = scrollTop < 50 * multiple - 78 * multiple;
            try {
                this.data
                    .concat()
                    .reverse()
                    .forEach((item) => {
                        let scrollTemplate = document.querySelector(`#${item.content}`)?.offsetTop;
                        if (scrollTemplate + scrollTop < -110 * multiple) {
                            this.$refs.tree?.setCurrentKey(item.id);
                            throw new Error(item.id);
                        }
                    });
            } catch (error) {
                // console.log("高亮", error);
            }
        },
        // 点击左侧导航栏触发滚动
        handleNodeClick(data) {
            this.onlyScroll(data.content);
            setTimeout(() => {
                this.$refs.tree?.setCurrentKey(data.id);
            }, 0);
        },
        // 滚动
        onlyScroll(content) {
            const isMobile = window?.isMobile;
            document
                .querySelector(`#${content}`)
                ?.scrollIntoView({block: isMobile ? 'center' : 'start', inline: 'nearest'});
        },
        // 点击内容触发滚动
        htmlScroll(e) {
            let ele = e.target;
            if (ele?.tagName === 'A' && ele?.href === 'javascript:void(0);') {
                let dataset = ele?.dataset;
                dataset.content && this.onlyScroll(dataset.content);
            }
        }
    }
};
</script>
<style lang="scss" scoped>
.Policy-main {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  padding: calc($multiple * 78px) 0;
  width: 100%;
  box-sizing: border-box;
  background: #f6faff;
  flex-direction: column;

  .Policy-content {
	margin-top: calc($multiple * 72px);
	width: 100%;
	display: flex;
	justify-content: center;
	position: relative;
	width: calc($multiple * 1123px);

	.content-fixed {
	  position: fixed;
	  top: calc($multiple * 50px + $multiple * 33px + $multiple * 72px);
	  // margin-left: calc($multiple * -723px);
	  left: 50%;
	  transform: translateX(-50%);
	  margin-left: calc($multiple * -362px);
	}

	.Policy-content-left {
	  background: #f6faff;
	  width: calc($multiple * 400px);
	  overflow: hidden;
	  padding-top: calc($multiple * 40px);
	  padding-right: calc($multiple * 80px);

	  .Policy-guide-text {
		font-size: calc($multiple * 16px);
		font-family: PingFangSC-Semibold, PingFang SC;
		font-weight: 600;
		color: #000000;
		line-height: calc($multiple * 18px);
		margin-bottom: calc($multiple * 20px);
	  }

	  ::-webkit-scrollbar {
		display: block;
	  }

	  ::-webkit-scrollbar-thumb {
		background: rgba(204, 212, 219, 0.5);
	  }

	  .Policy-content-tree {
		// 总高度 - footer - header - content-fixed的top - Policy-content-left的padding-top - Policy-guide-text占用的高度
		max-height: calc(
				100vh - $multiple * 134px - $multiple * 50px - $multiple * 33px - $multiple * 72px -
				$multiple * 40px - $multiple * 38px
		);
		overflow: auto;
	  }

	  .el-tree ::v-deep {
		background: #f6faff;

		.el-tree-node {
		  margin-bottom: calc($multiple * 20px);
		  white-space: pre-wrap;

		  .el-tree-node__expand-icon {
			display: none;
		  }

		  .el-tree-node__content {
			height: auto;

			.el-tree-node__label {
			  font-size: calc($multiple * 14px);
			  font-family: PingFangSC-Regular, PingFang SC;
			  font-weight: 400;
			  color: #000000;
			  line-height: calc($multiple * 20px);
			}
		  }
		}

		.is-current {
		  > .el-tree-node__content {
			> .el-tree-node__label {
			  color: #0072f5 !important;
			}
		  }
		}
	  }
	}

	.Policy-content-right ::v-deep {
	  a {
		color: #0072F5;
	  }
		.head-img {
			width: 100%;
		}
		h1 {
			margin-top: 60px;
			font-size: calc($multiple * 24px);
		}
		h3 {
			font-size: calc($multiple * 16px);
		}
		.title {
			display: block;
			margin-bottom: 10px;
		}
		img.icon{
			width: calc($multiple * 48px);
			height: calc($multiple * 48px);
			display: inline;
			vertical-align: middle;
			margin-right: 10px;
			margin-top: -12px;
			margin-bottom: -12px;
		}
		.img-title{
			display: flex;
			align-items: center;
		}

		.mt-20{
			margin-top: 20px;
		}
		.mb-20{
			margin-bottom: 20px;
		}
		.lh-2 {
			line-height: 2em;
		}

		ul > li {
			list-style: none;
			line-height: 2em;
			display: block;
			&:before {
				content:"·";
				font-size: calc($multiple * 40px);
				vertical-align:middle;
			}
		}

	  width: calc($multiple * 723px);
	  font-size: calc($multiple * 14px);
	  font-family: PingFangSC-Regular, PingFang SC;
	  font-weight: 500;
	  color: #292929;
	  line-height: calc($multiple * 25px);
	  word-break: break-all;

	  .notice-title {
		margin-top: 0;
		margin-bottom: 25px;
		font-family: PingFangSC-Semibold;
		font-size: 16px;
		color: #222222;
		letter-spacing: 0;
		text-align: center;
		line-height: 18px;
	  }

	  .notice-content {
		white-space: pre-line;
		font-family: PingFangSC-Regular;
		font-size: 14px;
		color: #222222;
		letter-spacing: -0.14px;
		text-align: justify;
		line-height: 21px;
	  }

	  .privacy-modal {
		display: none;
		padding: 59px;
		position: absolute;
		left: 50%;
		width: 476px;
		z-index: 20;
		background: white;
		top: 50%;
		transform: translate(-50%, -50%);
		border-radius: 5px;
	  }

	  .notice-button {
		display: flex;
		justify-content: center;
		align-items: center;
		margin: 30px auto 0;
		width: 124px;
		height: 48px;
		color: white;
		background: #3072f6;
		font-family: PingFangSC-Semibold;
		font-size: 16px;
		color: #ffffff;
		letter-spacing: 0;
		text-align: center;
		line-height: 16px;
		cursor: pointer;
		border-radius: 2px;
	  }

	  li {
		list-style: none;
	  }

	  li a {
		outline: none;
		text-decoration: none;
	  }

	  .protocol {
		position: absolute;
		top: 100px;
		bottom: 100px;
		left: 50%;
		min-height: 500px;
		margin-left: -480px;
		width: 960px;
		overflow: auto;
		color: #101d37;
		background-color: #ffffff;
		border-radius: 4px;
		border: 1px solid #e5e5e6;
		box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.16);
	  }

	  .logo-wrap {
		position: absolute;
		top: 28px;
		left: 50%;
		margin-left: -480px;
		width: 960px;
		overflow: auto;
	  }

	  .wrap {
		padding: 30px;
	  }

	  .logo-wrap {
	  }

	  .logo {
		width: 180px;
	  }

	  p {
		margin: calc($multiple * 30px) 0;
	  }

	  .p3 {
		margin-top: 10px;
		margin-bottom: 10px;
	  }

	  .p1 {
		font-size: 32px;
		font-weight: bold;
		text-align: center;
		margin-bottom: 40px;
	  }

	  strong {
		font-family: PingFangSC-Medium, PingFang SC;
	  }
	}
  }
}

.Policy-main-mobile {
  padding: 2.1rem 0 1.54rem;

  .Policy-content {
	margin-top: 1.43rem;
	width: 17.15rem;
	flex-direction: column;
	font-size: 0.61rem;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: rgba(0, 0, 0, 0.84);
	line-height: 0.98rem;
	letter-spacing: 0.05rem;
	text-align: justify;
	word-break: break-all;
  }
}
</style>
